/**

 * Backup patch if module loads before head inline script (dev HMR edge cases).

 * Production: vite legacyAtPolyfillPlugin injects sync script first in `<head>`.

 */

function patchAt(proto: object) {

	if (typeof (proto as { at?: unknown }).at === 'function') return;

	Object.defineProperty(proto, 'at', {

		value(index: number) {

			const len = (this as { length: number }).length;

			const i = index >= 0 ? index : len + index;

			if (i < 0 || i >= len) return undefined;

			return (this as ArrayLike<unknown>)[i];

		},

		writable: true,

		configurable: true,

	});

}



patchAt(Array.prototype);

patchAt(String.prototype);



const typedArrayNames = [

	'Int8Array',

	'Uint8Array',

	'Uint8ClampedArray',

	'Int16Array',

	'Uint16Array',

	'Int32Array',

	'Uint32Array',

	'Float32Array',

	'Float64Array',

	'BigInt64Array',

	'BigUint64Array',

] as const;



for (const name of typedArrayNames) {

	const Ctor = (globalThis as Record<string, { prototype: object } | undefined>)[name];

	if (Ctor) patchAt(Ctor.prototype);

}

if (typeof String.prototype.replaceAll !== 'function') {
	Object.defineProperty(String.prototype, 'replaceAll', {
		value(this: string, search: string | RegExp, replacement: string) {
			if (search instanceof RegExp) {
				if (!search.global) {
					throw new TypeError('String.prototype.replaceAll called with a non-global RegExp');
				}
				return this.replace(search, replacement);
			}
			return String(this)
				.split(String(search))
				.join(replacement == null ? '' : String(replacement));
		},
		writable: true,
		configurable: true,
	});
}


